import React from "react";
import Paper from "@material-ui/core/Paper";
import Slider from "@material-ui/core/Slider";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";

import { SkeletonState } from "./State";
import { gql } from "apollo-boost";
import * as d3 from "d3-interpolate";

const DECODING_QUERY = gql`
  query decode($encoding: [[Float]]!) {
    decode(encoding: $encoding, modelVersion: 10) {
      image
      encoding
    }
  }
`;

function generateAndSetEncodings(
  initialState,
  finalState,
  steps = 10,
  setEncodings
) {
  if (
    initialState.encoding === undefined ||
    finalState.encoding === undefined
  ) {
    setEncodings(null);
    return;
  }
  const interp = d3.interpolate(initialState.encoding, finalState.encoding);
  const encodings = [];
  for (let i = 0; i < steps; i++) {
    const point = interp(i / (steps - 1));
    encodings.push([...point]);
  }
  setEncodings(encodings);
}

function fetchAndSetReconstructions(client, encodings, setReconstructions) {
  if (encodings !== null) {
    client
      .query({
        query: DECODING_QUERY,
        variables: {
          encoding: encodings
        }
      })
      .then(result => {
        const decodings = result.data.decode;
        setReconstructions(decodings.map(d => d.image));
      })
      .catch(err => console.error(err));
  } else {
    setReconstructions(null);
  }
}

function StateInterpolator(props) {
  const { client, initialState, finalState } = props;
  const [index, setIndex] = React.useState(0);
  const [encodings, setEncodings] = React.useState(null);
  const [reconstructions, setReconstructions] = React.useState(null);

  React.useEffect(() => {
    setIndex(0);
    setEncodings(null);
    setReconstructions(null);
    if (initialState && finalState) {
      generateAndSetEncodings(initialState, finalState, 10, setEncodings);
    }
  }, [initialState, finalState]);

  React.useEffect(() => {
    setReconstructions(null);
    if (encodings !== null) {
      fetchAndSetReconstructions(client, encodings, setReconstructions);
    }
  }, [client, encodings]);

  const onSliderChange = (event, value) => {
    setIndex(value);
  };

  let reconstruction = null;
  if (reconstructions !== null && index < reconstructions.length) {
    reconstruction = reconstructions[index];
  }

  return (
    <Paper
      style={{ maxWidth: "500px", margin: "20px auto", position: "relative" }}
    >
      <Card style={{ padding: "10px", textAlign: "center" }}>
        <SkeletonState image={reconstruction} loading={encodings !== null} />
        <CardActions>
          {reconstructions && (
            <Slider
              defaultValue={0}
              value={index}
              aria-labelledby="discrete-slider"
              valueLabelDisplay="auto"
              step={1}
              marks
              min={0}
              max={reconstructions.length - 1}
              onChange={onSliderChange}
            />
          )}
        </CardActions>
        <CardContent
          style={{
            textAlign: "left"
          }}
        >
          {encodings && (
            <React.Fragment>
              <Typography color="textSecondary" gutterBottom>
                Encoding:
              </Typography>
              <pre
                style={{
                  textAlign: "left",
                  height: "50px",
                  maxWidth: "500px",
                  overflowX: "scroll",
                  whiteSpace: "nowrap",
                  padding: "0 16px"
                }}
              >
                {JSON.stringify(encodings[index])}
              </pre>
            </React.Fragment>
          )}
        </CardContent>
      </Card>
    </Paper>
  );
}

export default StateInterpolator;



// WEBPACK FOOTER //
// ./src/sections/data/components/StateInterpolator.js